(() => {
  const root = document.getElementById('gf-wishlist');
  if (!root) return;
  const key = 'gf-wishlist-v1';
  const opener = root.querySelector('[data-gf-open]');
  const icons = document.querySelector('header .header__icons');
  if (icons) icons.prepend(opener);
  const dialog = root.querySelector('dialog');
  let items = [];
  try { const saved = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(saved)) items = saved.filter(p => p && /^[a-z0-9-]+$/.test(p.handle) && typeof p.title === 'string').slice(0,200); } catch {}
  const update = () => {
    document.querySelectorAll('[data-gf-save]').forEach(button => {
      const active = items.some(p => p.handle === button.dataset.handle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? root.dataset.remove : root.dataset.save);
    });
    document.querySelector('[data-gf-count]').textContent = items.length;
  };
  const persist = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); items = next; update(); return true; }
    catch { root.querySelector('[data-gf-status]').textContent = root.dataset.error; return false; }
  };
  const render = () => {
    const list = root.querySelector('[data-gf-list]'); list.replaceChildren();
    if (!items.length) { const p = document.createElement('p'); p.textContent = root.dataset.empty; list.append(p); }
    items.forEach(item => {
      const row = document.createElement('article');
      const link = document.createElement('a'); link.href = '/products/' + item.handle;
      if (item.image && /^(https:\/\/|\/\/)/.test(item.image)) { const img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; link.append(img); }
      const title = document.createElement('span'); title.textContent = item.title; link.append(title);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = root.dataset.remove;
      remove.addEventListener('click', () => { if (persist(items.filter(p => p.handle !== item.handle))) render(); });
      row.append(link, remove); list.append(row);
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gf-save]');
    if (button) { event.preventDefault(); const exists = items.some(p => p.handle === button.dataset.handle); persist(exists ? items.filter(p => p.handle !== button.dataset.handle) : [...items, {handle:button.dataset.handle,title:button.dataset.title,image:button.dataset.image}].slice(-200)); }
    if (event.target.closest('[data-gf-open]')) { render(); dialog.showModal(); }
    if (event.target.closest('[data-gf-close]')) dialog.close();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  window.addEventListener('storage', event => { if (event.key === key) { try { const saved = JSON.parse(event.newValue || '[]'); if (Array.isArray(saved)) items = saved.filter(p=>p && /^[a-z0-9-]+$/.test(p.handle) && typeof p.title === 'string').slice(0,200); update(); if(dialog.open) render(); } catch {} } });
  new MutationObserver(update).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  update();
})();
